import { render, staticRenderFns } from "./TalentsTable.vue?vue&type=template&id=d91d6b2a&"
import script from "./TalentsTable.vue?vue&type=script&lang=js&"
export * from "./TalentsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports